import React, { useState } from 'react';
import { API } from '../lib/api';
import { useT } from '../lib/i18n';

/**
 * BookDownloadButton — fetches the licence-gated PDF as a blob and triggers
 * a browser download with a clean filename. Lives in Settings (and could be
 * embedded elsewhere) so the buyer can redownload the book any time, not
 * just immediately after checkout.
 */
export default function BookDownloadButton({ className = '' }) {
  const { t } = useT();
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');

  const downloadBook = async () => {
    setDownloading(true);
    setError('');
    try {
      const deviceId = localStorage.getItem('ctl_device_id') || '';
      const res = await fetch(`${API}/book`, { headers: { 'X-Device-Id': deviceId } });
      if (!res.ok) throw new Error(`book fetch failed: ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Connection-is-Love.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('BookDownloadButton.downloadBook failed:', e);
      setError(t('welcome.failed'));
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={className}>
      <button
        onClick={downloadBook}
        disabled={downloading}
        className="ctl-btn font-pressura font-bold disabled:opacity-40"
        data-testid="settings-download-book-btn"
      >
        {downloading ? t('welcome.downloading') : t('welcome.download')}
      </button>
      {error && (
        <p className="ctl-helper text-sm mt-3 text-[#8B2A18]" data-testid="settings-download-error">
          {error}
        </p>
      )}
    </div>
  );
}
